// PageWithBack.js
import React from "react";
import BackButton from "./BackButton";

export default function PageWithBack({ children }) {
  return (
    <div>
      <BackButton />
      <div style={{ marginTop: "50px" }}>{children}</div> {/* To avoid overlapping */}
    </div>
  );
}
